<template>
  <div>
    <div v-if="isSquare" class="switch-container switch-container--square">
      <input
        :checked="modelValue"
        class="switch-input"
        type="checkbox"
        role="checkbox"
        :aria-checked="modelValue"
        @change="onInputChange" />
      <svg
        class="toggle box"
        viewBox="0 0 180 71"
        xmlns="http://www.w3.org/2000/svg"
        tabindex="0"
        @keydown.space.prevent="toggle">
        <rect
          class="switch-background"
          x="0"
          y="2.5"
          width="71"
          height="67"
          rx="12.5"
          ry="12.5" />
        <rect class="switch-background" x="70" y="20" width="41" height="30" />
        <rect
          class="switch-background"
          x="110"
          y="2.5"
          width="70"
          height="67"
          rx="12.5"
          ry="12.5" />
        <text class="switch-text on" x="35" y="40" text-anchor="middle">
          {{ textLeft }}
        </text>
        <text class="switch-text off" x="145" y="40" text-anchor="middle">
          {{ textRight }}
        </text>
        <g filter="url('#goo')">
          <rect
            class="switch-square-center"
            x="6.5"
            y="21"
            width="58"
            height="29" />
          <rect class="switch-square left" x="7" y="7" width="57" height="57" />
          <rect
            class="switch-square right"
            x="117"
            y="7"
            width="57"
            height="57" />
        </g>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="5" />
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
            result="goo" />
        </filter>
      </svg>
    </div>

    <div v-else-if="isNormal" class="switch-container switch-container--normal">
      <input
        :checked="modelValue"
        class="switch-input"
        type="checkbox"
        role="checkbox"
        :aria-checked="modelValue"
        @change="onInputChange" />
      <svg
        class="toggle normal"
        viewBox="0 0 50 25"
        xmlns="http://www.w3.org/2000/svg"
        tabindex="0"
        @keydown.space.prevent="toggle">
        <rect
          class="switch-background"
          x="0.5"
          y="0.5"
          width="49"
          height="24"
          rx="12.5"
          ry="12.5" />
        <circle class="switch-circle" cx="12.5" cy="12.5" r="10" />
      </svg>
    </div>

    <div v-else class="switch-container">
      <input
        :checked="modelValue"
        class="switch-input"
        type="checkbox"
        role="checkbox"
        :aria-checked="modelValue"
        @change="onInputChange" />
      <svg
        class="toggle"
        viewBox="0 0 146 71"
        xmlns="http://www.w3.org/2000/svg"
        tabindex="0"
        @keydown.space.prevent="toggle">
        <path
          class="switch-background"
          d="M35.5 71C15.894 71 0 55.106 0 35.5C0 15.894 15.894 0 35.5 0C55.106 0 59.5 15 73 15C86.5 15 91 0 110.5 0C130 0 146 15.894 146 35.5C146 55.106 130.106 71 110.5 71C90.894 71 86.5 56 73 56C59.5 56 55.106 71 35.5 71Z" />
        <rect
          class="switch-icon on"
          x="32"
          y="19.5"
          width="6"
          height="32"
          rx="3" />
        <path
          class="switch-icon off"
          fill-rule="evenodd"
          d="M110.5 45.5C116.023 45.5 120.5 41.023 120.5 35.5C120.5 29.977 116.023 25.5 110.5 25.5C104.977 25.5 100.5 29.977 100.5 35.5C100.5 41.023 104.977 45.5 110.5 45.5ZM110.5 51.5C119.337 51.5 126.5 44.337 126.5 35.5C126.5 26.663 119.337 19.5 110.5 19.5C101.663 19.5 94.5 26.663 94.5 35.5C94.5 44.337 101.663 51.5 110.5 51.5Z" />
        <g filter="url('#goo')">
          <rect
            class="switch-circle-center"
            x="6.5"
            y="21"
            width="58"
            height="29"
            rx="14.5"
            fill="#fff" />
          <rect
            class="switch-circle left"
            x="7"
            y="7"
            width="57"
            height="57"
            rx="28.5"
            fill="#fff" />
          <rect
            class="switch-circle right"
            x="82"
            y="7"
            width="57"
            height="57"
            rx="28.5"
            fill="#fff" />
        </g>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="5" />
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
            result="goo" />
        </filter>
      </svg>
    </div>
  </div>
</template>
<script setup lang="ts">
const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  isSquare: { type: Boolean, default: false },
  textLeft: { type: String, default: 'Ja' },
  textRight: { type: String, default: 'Nej' },
  modelValue: { type: Boolean, default: false },
  isNormal: { type: Boolean, default: false }
});

function onInputChange(event: any) {
  emit('update:modelValue', event.target.checked);
}

function toggle() {
  emit('update:modelValue', !props.modelValue);
}
</script>
<style lang="scss"></style>
